import { Component, OnInit } from "@angular/core";
import { TranslateService } from "../translate";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html"
})
export class HeaderComponent implements OnInit {

	public translatedText: string;
	public supportedLanguages: any[];
	public supportedLangs: any[];

	constructor(private _translate: TranslateService) {
	}

	public ngOnInit() {
		this.supportedLangs = [
			{ display: "English", value: "en", icon: "flag" },
			{ display: "Español", value: "es", icon: "flag" },
			{ display: "X Lang", value: "xx", icon: "polymer" },
		];
		this.selectLang("en");
	}

	public isCurrentLang(lang: string) {
		// check if the selected lang is current lang
		return lang === this._translate.currentLang;
	}

	public selectLang(lang: string) {
		// set current lang;
		this._translate.use(lang);
		this.refreshText();
	}

	public refreshText() {
		// refresh translation when language change
		this.translatedText = this._translate.instant("hello world");
	}
}
